import errorNotification from './save-traveller-profile-error-message.html';

AdultTravellerService.SERVICE_NAME = 'adultTravellerService';

export default function AdultTravellerService(
    $http,
    userService,
    tripFactory,
    tripService,
    travellerUtils,
    $uibModal,
    $q
) {
    'ngInject';

    Object.assign(this, {
        saveTravellerProfile,
        updateTravellerProfile,
        isProfileComplete,
        updateClubCards,
    });

    function saveTravellerProfile(profile, isFlightPresent, isGenderRequired, apisTsaSettings) {
        const processedProfile = getProcessedProfile(profile, isFlightPresent, isGenderRequired, apisTsaSettings);
        const url = '/Authorize/CreateTravellerProfile';

        return $http.apiPOST(url, processedProfile, {skipErrorInterceptor: true})
            .catch(showError);
    }

    function updateTravellerProfile(profile, isFlightPresent, isGenderRequired, apisTsaSettings) {
        const processedProfile = getProcessedProfile(profile, isFlightPresent, isGenderRequired, apisTsaSettings);
        const url = '/Authorize/UpdateTravellerProfile';

        return $http.apiPOST(url, processedProfile, {skipErrorInterceptor: true})
            .catch(showError);
    }

    function getProcessedProfile(profile, isFlightPresent = false, isGenderRequired = false, apisTsaSettings = null) {
        const {
            FirstName, LastName, MiddleName,
            Title, EmailAddress,
            TelephoneNumberCallingCode, TelephoneNumber,
            TripPassengerId, TravellerProfileId,
        } = profile;
        let {ClubCards} = profile;

        ClubCards = travellerUtils.getProcessedClubCards(ClubCards);

        const processedProfile = {
            FirstName,
            LastName,
            MiddleName,
            Title: Title.text,
            EmailAddress,
            TelephoneNumberCallingCode: TelephoneNumberCallingCode.value,
            TelephoneNumber,
            ClubCards,
            TravellerFlightDetails: {},
        };

        Object.assign(processedProfile, {
            TravellerProfileId,
            TripPassengerId,
        });

        if (isGenderRequired) {
            const Gender = getGender(profile);
            Object.assign(processedProfile, {Gender});
            Object.assign(processedProfile.TravellerFlightDetails, {Gender});
        }

        if (isFlightPresent) {
            const {KnownTravellerNumber, RedressNumber} = profile.TravellerFlightDetails;
            Object.assign(processedProfile.TravellerFlightDetails, {
                KnownTravellerNumber, RedressNumber,
            });
        }

        if (tripFactory.apisHasLevel(0, apisTsaSettings)) {
            const {DateOfBirth} = profile.TravellerFlightDetails;
            Object.assign(processedProfile.TravellerFlightDetails, {
                DateOfBirth: getFormattedDate(DateOfBirth),
            });
        }

        if (tripFactory.apisHasLevel([0, 1], apisTsaSettings) && isFlightPresent) {
            const {
                PassportIssuingCountryCode, NationalityCode,
                PassportNumber, PassportExpiryDate,
            } = profile.TravellerFlightDetails;
            Object.assign(processedProfile.TravellerFlightDetails, {
                PassportNumber,
                PassportExpiryDate: getFormattedDate(PassportExpiryDate),
                PassportIssuingCountryCode: PassportIssuingCountryCode.value,
                NationalityCode: NationalityCode.value,
            });
        }

        return processedProfile;
    }

    function getFormattedDate(date) {
        const {dateFormat} = userService.getRegionalSettings();
        return _.isDate(date)
            ? moment(date)
                .utcOffset(0, true)
                .format()
            : moment(date, dateFormat)
                .utcOffset(0, true)
                .format();
    }

    function showError(error) {
        $uibModal.open({
            template: errorNotification,
            size: 'md',
        });
        return $q.reject(error);
    }

    function isProfileComplete(profile) {
        const hasAllBasicInfo = isAllBasicInfoProvided(profile);
        const hasMissingFields = isMissingFields(profile);
        if (!hasAllBasicInfo) {
            return false;
        }

        if (hasMissingFields) {
            return false;
        }

        return true;
    }

    function isAllBasicInfoProvided(profile) {
        const {
            FirstName, LastName,
            Title, EmailAddress,
            TelephoneNumberCallingCode, TelephoneNumber,
        } = profile;

        return !!FirstName
            && !!LastName
            && !!Title
            && !!EmailAddress
            && !!TelephoneNumber
            && !!TelephoneNumberCallingCode;
    }

    function getGender(profile) {
        return profile.TravellerFlightDetails
            && profile.TravellerFlightDetails.Gender
            && profile.TravellerFlightDetails.Gender.value;
    }

    function updateClubCards(travellers, editedAdult) {
        if (travellers) {
            const traveller = travellers.find(({Id}) => editedAdult.Id === Id);
            if (traveller) {
                editedAdult.ClubCards = traveller.ClubCards;
            }
        }
    }

    function isMissingFields(profile) {
        if (angular.isDefined(profile.MissingFields) && Array.isArray(profile.MissingFields) && profile.MissingFields.length > 0) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/adult-traveller-service.js